import * as yup from 'yup';
import { YSmsCodeValidate, YRequiredPhoneValidate } from '../yupValidators';
export const mfaPhoneInitialValues = {
  phone: ''
};
export const mfaPhoneSchema = yup.object({
  phone: YRequiredPhoneValidate
});
export const mfaSmsCodeInitialValues = {
  code: ''
};
export const mfaSmsCodeSchema = yup.object().shape({
  code: YSmsCodeValidate
});